@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.activityContainer {
  display: block;
  border-radius:  hevo-toolkit-variables.$border-radius-md;
  overflow: hidden;
  border: solid  hevo-toolkit-variables.$border-width  hevo-toolkit-variables.$divider-color;

  .activityCard {
    padding:  hevo-toolkit-variables.$spacer * 0.625  hevo-toolkit-variables.$spacer * 1.25;
    position: relative;
    display: flex;
    &::before {
      content: '';
      width: 2px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .activityCardLeft {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      white-space: nowrap;
      color: var(--text-default-color);
      line-height: 21px;

      a {
        color: var(--text-primary-color);
        font-weight: 700;
      }

      pre {
        white-space: inherit;
      }
    }

    .activityCardRight {
      width: 256px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left:  hevo-toolkit-variables.$spacer * 2;
      height: 20px;

      .activityCardWrapper {
        display: flex;
        align-items: center;
        overflow: hidden;

        .activityCardWrapperTime {
          flex-shrink: 0;
          color: var(--text-default-color);
        }

        .activityCardWrapperAuthor {
          color:  hevo-toolkit-variables.$text-secondary;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-right:  hevo-toolkit-variables.$spacer * 2.5;
        }
      }
    }

    &.shimmerContainer {
      padding:  hevo-toolkit-variables.$spacer * 0.442  hevo-toolkit-variables.$spacer * 1.25;

      .shimmerBig {
        width: 210px;
      }

      .shimmerSmall {
        width: 50px;
      }

      .shimmerCircle {
        height: 12px;
        width: 12px;
      }
    }
  }

  .activity {
    background-color: var(--surface-bg-color);
    border-bottom: solid var(--border-width) var(--divider-color);
    display: block;
    width: 100%;
    &.default {
      .activityCard:before {
        background: var(--default-secondary-color);
      }
    }

    &.info {
      .activityCard:before {
        background: var(--info-color);
      }
    }

    &.warning {
      .activityCard:before {
        background: var(--warning-color);
      }
    }

    &.error {
      .activityCard:before {
        background: var(--error-color);
      }
    }

    &:last-child {
      border-bottom: 0;
    }

    &.expanded,
    &.activityDetails {
      background-color: var(--secondary-bg-color);

      .activityCardLeft {
        white-space: normal;
        -webkit-transition: white-space 200ms linear;
        -ms-transition: white-space 200ms linear;
        transition: white-space 200ms linear;

        pre {
          white-space: inherit;
        }
      }
    }

    .activityJsonViewer {
      height: 200px
    }
  }

  &.loadMoreContainer {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &.loadMoreBottomContainer {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 0;
  }
}
